import { useEffect, useState } from "react";
import genericStyles from "../../Styles/genericStyles.module.css";
import { EComponentTypes, ETableEditAction } from "../../Utils/Enums";
import {
  ClientModel,
  OrderStatusModel,
  ProductModel,
  UserModel,
  WorkPointModel,
} from "../../Utils/Models";
import { endpoints } from "../../Utils/UrlEnum";
import { formatDate, getFullName } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { getData } from "../../Services/getData";
import Filters from "../Widgets/Filters";
import useCustomMemo from "../../Hooks/useCustomMemo";

export default function ReminderCategoryExpiration() {
  const [products, setProducts] = useState<ProductModel[]>([]);
  const memo = useCustomMemo();
  const workPoints: WorkPointModel[] = memo?.storage?.workPoints;

  /**
   * Retrieves all products from the server and stores them in the state.
   * The function does not return anything.
   * If the response contains no data, the function exits early.
   */
  const getProducts = async () => {
    const res = await getData(
      `${endpoints.product.main}/paginated?page=0&perPage=100000`
    );
    if (!res?.data) return;
    setProducts(res.data?.results);
  };

  /**
   * UseEffect hook to retrieve all products when the component mounts.
   */
  useEffect(() => {
    getProducts();
  }, []);

  const columns = [
    {
      name: "orderNumber",
      label: Vocabulary.id,
    },
    {
      name: "workPointDetails",
      label: Vocabulary.workPoint,
      options: {
        sortField: "workPointDetails.name",
        customBodyRender: (workPoint: WorkPointModel) => {
          return workPoint?.name;
        },
      },
    },
    {
      name: "clientDetails",
      label: Vocabulary.cursant,
      options: {
        sortField: "clientDetails.firstName",
        customBodyRender: (client: ClientModel) => {
          return getFullName(client);
        },
      },
    },
    {
      name: "instructorUserDetails",
      label: Vocabulary.instructor,
      options: {
        sortField: "instructorUserDetails.firstName",
        customBodyRender: (instructor: UserModel) => {
          return getFullName(instructor);
        },
      },
    },
    {
      name: "orderStatus",
      label: Vocabulary.status,
      options: {
        sortField: "orderStatus.name",
        customBodyRender: (orderStatus: OrderStatusModel) => {
          return orderStatus?.name;
        },
      },
    },
    {
      name: "monthsSinceCreated",
      label: Vocabulary.months,
    },
    {
      name: "createdAt",
      label: Vocabulary.createdAt,
      options: {
        customBodyRender: (createdAt: Date) => {
          return formatDate(createdAt);
        },
      },
    },
  ];

  const filters = [
    {
      property: "productId",
      autocompleteFilterProperty: "_id",
      label: Vocabulary.category,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: null,
      options: products,
    },
    {
      property: "workPointId",
      autocompleteFilterProperty: "_id",
      label: Vocabulary.workPoint,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: null,
      defaultValue: null,
      options: workPoints,
    },
  ];
  
  return (
    <div className={genericStyles.mainContainer}>
      <Filters defaultOpen filters={filters} />
      <MUIDataTableCustomStyle
        buttons={[]}
        onEditAction={ETableEditAction.NONE}
        title={""}
        hideAddButton={true}
        columns={columns}
        CRUDEndPoint={endpoints.orderExpiration}
        hideEditButton={true}
        hideDeleteButton={true}
      />
    </div>
  );
}
